import { call, put } from "redux-saga/effects";
import { api } from "../../../services";
import { Creators } from "./index";

import { Alerts } from "../../../lib";

export default function* editMultipleQueries({ data, callback }) {
  try {
    const requestData = {
      id: data?.list,
      signalCreditRelease:
        data?.signalCreditReleaseId !== null
          ? parseInt(data?.signalCreditReleaseId)
          : 2,
    };
    yield call(api.sendMultipleAnalysisResponse, requestData);

    yield put(Creators.editMultipleQueriesSuccess());
    callback();
  } catch (response) {
    Alerts.alertError(
      response?.data?.log
        ? response?.data?.log
        : "Não foi possível modificar as liberações"
    );

    yield put(Creators.editMultipleQueriesFailure());
  }
}
